export default __webpack_public_path__ + "static/media/optum-glyph.1a6c2a4d.png";